var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VButton',{staticClass:"administration-form--self-start",attrs:{"disabled":!_vm.inn,"loading":_vm.isLoading,"color":"primary","outlined":"","small":"","type":"button"},on:{"click":_vm.handleFindByINN}},[_vm._v(_vm._s(_vm.$t('page.administration.findByINN'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }